function ifEqual(first, second, block) {
  if (
    first.every &&
    first.period &&
    second.every &&
    second.period &&
    first.every.toString() === second.every.toString() &&
    first.period.toString() === second.period.toString()
  )
    return block.fn(this);

  if (first === second) {
    return block.fn(this);
  }
  return '';
}

module.exports = ifEqual;
